import React from "react";
import { ShieldCheck, Droplets, Wrench, Move, Settings, Camera, Sparkles, CheckCircle2 } from "lucide-react";

const STEPS = [
  { key: "authenticity_checked", label: "Authenticity Checked", icon: ShieldCheck },
  { key: "condition_graded", label: "Condition Graded", icon: CheckCircle2 },
  { key: "ultrasonically_cleaned", label: "Ultrasonically Cleaned", icon: Droplets },
  { key: "hinges_checked", label: "Hinges Checked", icon: Wrench },
  { key: "alignment_checked", label: "Frame Alignment Checked", icon: Move },
  { key: "individually_serviced", label: "Individually Serviced", icon: Settings },
  { key: "photographed", label: "Photographed", icon: Camera },
  { key: "ready_to_wear", label: "Ready To Wear", icon: Sparkles },
];

/** Shows ONLY completed inspection steps - never claims a step that hasn't actually been done. */
export function LookersInspection({ inspection }) {
  const completed = STEPS.filter((s) => inspection?.[s.key]);
  if (completed.length === 0) return null;
  return (
    <div className="border border-neutral-200 rounded-2xl p-5 sm:p-6" data-testid="lookers-inspection">
      <div className="text-teal-600 text-xs font-heading font-bold uppercase tracking-[0.15em] mb-4">The Lookers Inspection</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {completed.map((s) => (
          <div key={s.key} className="flex flex-col items-center text-center gap-2" data-testid={`inspection-step-${s.key}`}>
            <div className="w-10 h-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-600">
              <s.icon size={18} strokeWidth={2} />
            </div>
            <span className="text-[11px] font-heading font-semibold text-neutral-700 leading-tight">{s.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export const INSPECTION_STEPS = STEPS;
